import React from "react";
import { Check } from "lucide-react";
import { CASE_STAGES } from "../data/mock";

export const StageTracker = ({ activeIndex }) => (
  <div data-testid="stage-tracker" className="relative pl-2">
    {CASE_STAGES.map((stage, i) => {
      const done = i < activeIndex;
      const active = i === activeIndex;
      return (
        <div key={stage.key} className="relative flex gap-4 pb-6 last:pb-0">
          {i < CASE_STAGES.length - 1 && (
            <span
              className={`absolute left-[11px] top-6 bottom-0 w-px ${
                done ? "bg-signal" : "bg-border"
              }`}
            />
          )}
          <span
            className={`relative z-10 mt-0.5 h-6 w-6 shrink-0 flex items-center justify-center border ${
              done
                ? "bg-signal border-signal text-white"
                : active
                ? "bg-white border-signal text-signal"
                : "bg-white border-border text-muted-foreground"
            }`}
          >
            {done ? (
              <Check className="h-3.5 w-3.5" strokeWidth={2} />
            ) : (
              <span className="font-mono text-[10px]">{i + 1}</span>
            )}
          </span>
          <div className="pt-0.5">
            <div
              className={`text-sm font-medium ${
                active ? "text-signal" : done ? "text-ink" : "text-muted-foreground"
              }`}
            >
              {stage.label}
              {active && (
                <span className="ml-2 font-mono text-[10px] uppercase tracking-wider text-signal border border-signal px-1.5 py-0.5">
                  Current
                </span>
              )}
            </div>
            <div className="text-xs text-muted-foreground mt-0.5">{stage.desc}</div>
          </div>
        </div>
      );
    })}
  </div>
);
